








































































































import {
  BSidebar,
  BSpinner,
  BForm,
  BButton,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormFile,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { OutilSuiviEnvTravail, UpdateOutilSuiviEnvTravailModel } from '../../../api/models/outilsSuiviEnvTravail/outilSuiviEnvTravail';
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BSidebar,
    BCol,
    BSpinner,
    BButton,
    BFormInput,
    BForm,
    BFormGroup,
    BFormFile,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class UpdateOutilSuiviEnvTravail extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateOutilSuiviEnvTravailSidebarActive!: boolean;
  @Prop({ required: true }) outilSuiviEnvTravailId!: string;

  loading = false;
  required = required;
  loadingOutilSuiviEnvTravail = false;
  isAddFileEnabled = false;

  outilSuiviEnvTravail: UpdateOutilSuiviEnvTravailModel = {};

 async created() {
    await this.$http.myressif.entreprises
      .getOutilSuiviEnvTravailById(
        this.$route.params.id,
        this.outilSuiviEnvTravailId
      )
      .then((res: OutilSuiviEnvTravail) => {
        this.outilSuiviEnvTravail = res;
        this.loadingOutilSuiviEnvTravail = true;
      });
  }

  resetForm() {
    this.outilSuiviEnvTravail = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.entreprises
      .updateOutilSuiviEnvTravailEntreprise(
        this.$route.params.id,
        this.outilSuiviEnvTravail.id,
        this.outilSuiviEnvTravail
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification de l'outil de suivi environnement de travail",
            text: "Outil de suivi environnement de travail modifié avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-outils-suivi-env-travail");
        this.$emit("update:is-update-outil-suivi-env-travail-sidebar-active", false);
        this.loading = false;
        this.isAddFileEnabled = false;
      });
  }
}
